import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import IndustrialCaseStudy from "./sections/IndustrialCaseStudy";
import Portfolio from "./sections/Portfolio";
import Portfolionavigationtabs from "./sections/Portfolionavigationtabs";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <Hero />
      <Portfolionavigationtabs />
      <IndustrialCaseStudy />
      <Portfolio />
      <Footer />
    </div>;
}